 

import { useState } from "react";
import uploadToCloudinary from "../utils/upload"; // Teri upload utility

function PickupOTPButton({ item, currentUser }) {
  // 1. Check karo: Kya User pehle se Verified hai? (One-Time Logic) 🧠
  // Agar user.idProof database me hai, to isVerified = true
  const [isVerified, setIsVerified] = useState(currentUser?.idProof ? true : false);
  
  const [showOtp, setShowOtp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [file, setFile] = useState(null);

  // 2. Button Click Handler
  const handleRevealClick = () => {
    if (isVerified) {
      // ✅ Agar verified hai -> Seedha OTP dikhao (No Drama)
      setShowOtp(true);
    } else {
      // ❌ Agar verified nahi hai -> Modal kholo (One-Time Upload)
      setShowModal(true);
    }
  };

  // 3. Upload Logic (Sirf First Time walon ke liye)
  const handleUploadID = async () => {
    if (!file) return alert("Please select ID photo!");
    setLoading(true);

    try {
      // A. Cloudinary Upload
      const url = await uploadToCloudinary(file);

      // B. Backend Update (USER Profile update, not Order)
      const token = localStorage.getItem("token");
      const res = await fetch("https://borrowhub-backend.onrender.com/api/users/update-profile", {
        method: "PUT",
        headers: { 
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}` 
        },
        // 🔥 Hum sirf idProof update kar rahe hain
        body: JSON.stringify({ idProof: url }), 
      });

      const data = await res.json();
      
      if (data.success) {
        // ✅ Success!
        alert("ID Verified! Life-time access granted.");
        
        // Local state update karo taaki page reload na karna pade
        setIsVerified(true); 
        setShowOtp(true);    // Turant OTP dikha do
        setShowModal(false); // Modal band
        
        // LocalStorage bhi update kar dete hain taaki agle page refresh pe yaad rahe
        const updatedUser = { ...currentUser, idProof: url };
        localStorage.setItem("user", JSON.stringify(updatedUser));
      } else {
        alert("Error: " + data.message);
      }
    } catch (err) {
      alert("Upload Failed!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-3">
      {/* --- SCENE 1: BUTTON YA OTP DISPLAY --- */}
      {!showOtp ? (
        <button 
          className={`btn w-100 fw-bold shadow-sm ${isVerified ? "btn-success" : "btn-warning"}`}
          onClick={handleRevealClick}
        >
          {isVerified ? "🔓 Show Pickup OTP" : "🔐 Unlock OTP (Upload ID)"}
        </button>
      ) : (
        // 🔥 Ye raha wo "Message" style OTP (Page change nahi hoga)
        <div className="alert alert-success text-center border-2 border-success animate__animated animate__fadeIn">
          <small className="text-muted text-uppercase fw-bold" style={{fontSize: "10px"}}>
            Share this with Lender
          </small>
          <h1 className="fw-bold m-0 display-4 text-dark letter-spacing-2">
            {item.pickupOtp}
          </h1>
          <small className="text-danger fw-bold">Don't share if not at shop!</small>
        </div>
      )}

      {/* --- SCENE 2: MODAL (Sirf Unverified ke liye khulega) --- */}
      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.8)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header bg-dark text-white">
                <h6 className="modal-title">🛡️ One-Time Security Check</h6>
                <button className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body text-center">
                <p className="small text-muted mb-3">
                  To ensure safety, please upload your <strong>Aadhaar/DL</strong> once.
                  <br/>Next time, no upload needed!
                </p>

                <input 
                  type="file" 
                  accept="image/*" 
                  className="form-control mb-3"
                  onChange={(e) => setFile(e.target.files[0])}
                />

                <button 
                  className="btn btn-primary w-100 fw-bold"
                  onClick={handleUploadID}
                  disabled={loading}
                >
                  {loading ? "Verifying..." : "📸 Upload & Reveal OTP"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PickupOTPButton;